import React from "react";
import { Link } from "gatsby";

const ListTopic = ({ topicId, topic, def }) => (
  <div className="g-topic">
    <Link to={`/glossary/${topicId}`}>
      <h2>
        <span className="g-topic__title g-topic__title--color-black">
          {topic}
        </span>
      </h2>
    </Link>
    <div className="g-topic__def-div">
      <div className="g-topic__def">
        <p>{def}</p>
      </div>
      <div className="g-topic__read-more g-topic__read-more">
        <p>
          <Link to={`/glossary/${topicId}`}>
            <span className="read-more__span">
              Read more
              <span className="angle-double-right__icon angle-double-right"></span>
            </span>
          </Link>
        </p>
      </div>
    </div>
  </div>
);

export default ListTopic;
